import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import Box from '@mui/material/Box';
import { TextField, Select, FormControl, MenuItem } from '@mui/material'
import Button from '@mui/material/Button';

import MuiDialogAlert from '../components/MuiDialogAlert';
import LoadingOverlay from 'react-loading-overlay-ts';

import { secsToTimeOfDay, epochToHumanReadableTS, secsToHumanReadable } from '../components/Functions'

import axios from 'axios';

import AdminMenu from '../components/AdminMenu'

const columns = [
    { field: 'device_id', headerName: 'Device ID', width: 150 },
    { field: 'description', headerName: 'Location', width: 200 },
    { field: 'batt_adc', headerName: 'Batt ADC' },
    { field: 'batt_percent', headerName: 'Batt %' },
    { field: 'batt_update_timestamp', headerName: 'Batt Last Update', width: 200 },
    { field: 'last_wakeup', headerName: 'Last Wakeup', width: 200 },
    { field: 'next_wakeup', headerName: 'Next Wakeup', width: 200 }
]



const AdminViewDeviceHealth = () => {

    let navigate = useNavigate();

    const [deviceList, setDeviceList] = useState([]);
    const [deviceHealth, setDeviceHealth] = useState([]);
    const [loadingActive, setLoadingActive] = useState(false);
    const [loadingText, setLoadingText] = useState("Loading");
    const [modalHeader, setModalHeader] = useState("");
    const [modalBody, setModalBody] = useState("Update Successful");
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);
    const current_epoch = Math.floor(new Date().getTime() / 1000.0)

    // Start up : Load the list of available devices
    useEffect(() => {
        const getDevicesData = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getDevicesData";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });

                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }
                let data = response.data
                setDeviceList(response.data);

                // Manipulate data for table
                let tmp_array = []
                for (let index = 0; index < data.length; index++) {
                    const device = data[index];
                    
                    let tmp_json = {}

                    tmp_json.id = device.id
                    tmp_json.device_id = device.device_id
                    tmp_json.description = device.settings.description
                    tmp_json.batt_adc = device.status.latest_transaction.BATTERY.batt_adc
                    tmp_json.batt_percent = device.status.latest_transaction.BATTERY.batt_percent
                    tmp_json.batt_update_timestamp = device.status.latest_transaction.BATTERY.batt_update_timestamp
                    tmp_json.batt_update_epoch = device.status.latest_transaction.BATTERY.batt_update_epoch
                    tmp_json.last_wakeup = epochToHumanReadableTS(device.status.sleep_status.last_wakeup)
                    tmp_json.next_wakeup = epochToHumanReadableTS(device.status.sleep_status.next_wakeup)
                    tmp_json.next_wakeup_epoch = device.status.sleep_status.next_wakeup

                    tmp_array.push(tmp_json)
                }
                setDeviceHealth(tmp_array)

            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                // setError(error);

            }
        };

        // Call the fetchData function when the component mounts

        setLoadingActive(true);
        getDevicesData();
        setLoadingActive(false);


    }, [])

    function taskScheduleRowClick(e) {
        let data = e.row
        console.log(data)
    }

    return (
        <div align="left" style={{ height: "100%", padding: "30px" }} className='admin_pages'>
            <LoadingOverlay
                active={loadingActive}
                spinner
                text={loadingText}
                className="spinner_div"
            >

                <AdminMenu />

                <div style={{ height: 800, width: "100%" }}>
                    <Box
                        sx={{
                            height: 800,
                            width: '100%',
                            '& .dg-red': {
                                backgroundColor: '#ff0000',
                                color: '#ffffff',
                            },
                            '& .dg-amber': {
                                backgroundColor: '#ffc107',
                                color: '#000000',
                            },
                            '& .dg-green': {
                                backgroundColor: '#198754',
                                color: '#FFFFFF',
                            },
                        }}
                    >
                    <DataGrid
                        rows={deviceHealth}
                        columns={columns}
                        pageSize={50}
                        onRowClick={taskScheduleRowClick}
                        disableVirtualization
                        disableSelectionOnClick
                        getCellClassName={(params) => {
                            if (params.field === 'next_wakeup') {
                                if (params.row.next_wakeup_epoch < current_epoch){ // Next wakeup has already Lapsed
                                    return 'dg-red'
                                }
                                else{
                                    return 'dg-green'
                                }
                            }
                            if (params.field === 'batt_percent') {
                                if (params.row.batt_percent < 35){ // Critical: Batt very low
                                    return 'dg-red'
                                }
                                if (params.row.batt_percent > 35 && params.row.batt_percent < 70){ // Bad: Batt Going Low
                                    return 'dg-amber'
                                }
                                if (params.row.batt_percent > 70){ // Healthy
                                    return 'dg-green'
                                }
                            }
                            return ''
                        }}
                        components={{ Toolbar: GridToolbar }}
                        sx={{
                            '& .MuiTablePagination-selectLabel': {
                                paddingTop: '15px'

                            },
                            '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                            '& .MuiDataGrid-cell': { fontSize: 12 },
                            '& .MuiDataGrid-columnHeader': { fontSize: 12 },
                            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell--editing': {
                                outline: 'none', // Remove outline when cell is focused or editing
                                border: 'none', // Remove border when cell is focused or editing
                            }

                        }} />
                    </Box>
                </div>


                <div style={{ height: "20px" }}></div>

                <MuiDialogAlert
                    showModal={showModal}
                    handleClose={handleClose}
                    bodyContent={modalBody}
                    title={modalHeader}
                    bodyClass="whitespace"
                />


            </LoadingOverlay>
        </div>
    )
}

export default AdminViewDeviceHealth